import { useEffect, useState } from 'react';

import {
  useGetCreditFacilitiesByOrganizationQuery,
  GetCreditFacilitiesByOrganizationQueryGQLType,
} from './requests/getCreditFacilities.gql.generated';
import { useFeatureFlags } from '~/contexts/FeatureFlagProvider';
import { useUserAuthOrThrow } from '~/contexts/UserAuthProvider';

// Exports
export type CreditFacility = GetCreditFacilitiesByOrganizationQueryGQLType['organization']['creditFacilities'][number];
export const useCreditFacilities = () => {
  const { user } = useUserAuthOrThrow();
  const flags = useFeatureFlags();
  const [readyToFetch, setReadyToFetch] = useState(false);

  useEffect(() => {
    if (flags.doNotRemoveFeatureFlagProviderReady) setReadyToFetch(true);
  }, [flags.doNotRemoveFeatureFlagProviderReady]);

  return useGetCreditFacilitiesByOrganizationQuery({
    // Wait for feature flags to load
    skip: !readyToFetch,
    variables: {
      organizationId: user.organizationId,
      creditFacilitySlugsToHide: flags.creditFacilitySlugsToHide ?? [],
    },
  });
};
